import { humanizePriceRange } from '../../helpers/humanization.js';

const getBankrotstvoTerms = item => {
    // Стоимость, Оформление банкротства
    const conditions = [];
    // Стоимость
    const { minSum, maxSum } = item;
    const priceValue = humanizePriceRange({
        priceRange: {
            from: minSum,
            to: maxSum,
        },
        allowZero: false,
        defaultValue: 'По запросу',
    });
    conditions.push({
        value: priceValue === 'По запросу' ? priceValue : `${priceValue}/мес.`,
        description: 'Стоимость',
        key: 'price',
    });
    // Оформление банкротства
    const { timeBankrotstvo } = item;
    const timevalue = timeBankrotstvo ? `Около ${timeBankrotstvo} мес.` : 'Индивидуально';
    conditions.push({ value: timevalue, description: 'Срок оформления', key: 'time' });
    // Выгода
    let benefitValue;
    const { benefit, dictTerms } = item;
    if (benefit > 0 && (dictTerms?.includes('mounth') || dictTerms?.includes('all'))) {
        benefitValue = `до ${benefit} ₽`;
    }
    else {
        benefitValue = `от ${benefit} ₽`;
    }
    benefitValue && conditions.push({ value: benefitValue, description: 'Выгода', key: 'benefit' });
    return conditions;
};

export { getBankrotstvoTerms };
//# sourceMappingURL=bankrotstvo.js.map
